// extracted by mini-css-extract-plugin
module.exports = {"spin":"loading_spinner__spin__QOsiJ color__color_brand_secondary__Yl6zT","load6":"loading_spinner__load6__r3dBd","round":"loading_spinner__round__kV5YU"};